import {
  LEVEL,
} from '../actions/constants';

const initialState = {
  handling: false,
  data: {},
};

export default function level(state = initialState, action) {
  switch (action.type) {
    case LEVEL.handlers.fetch:
    case LEVEL.handlers.update:
    case LEVEL.handlers.import:
    case LEVEL.handlers.remove:
      return {
        ...state,
        handling: true,
      };
    case LEVEL.update:
      return {
        ...state,
        data: action.merge ? {
          ...state.data,
          ...action.data,
        } : action.data,
        handling: false,
      };
    default:
      return state;
  }
}
